import { render } from "./Dados.vue?vue&type=template&id=7d53344a&scoped=true"
import script from "./Dados.vue?vue&type=script&lang=js"
export * from "./Dados.vue?vue&type=script&lang=js"

import "./Dados.vue?vue&type=style&index=0&id=7d53344a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d53344a"]])

export default __exports__